@use 'ui/styles/core-tokens' as core;

.envVars {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &Info {
    margin-bottom: 16px;
    flex-direction: column;
    align-items: flex-start;
    max-height: fit-content !important;

    &Value {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
    }
  }

  &ShowBtn {
    margin-top: -4px;
  }
}
